import React, { FunctionComponent } from 'react';
import { Box } from '@mui/material';
import { useResponsive } from '../../contexts/ResponsiveContext';
import { AboutInvestorRelationsOverviewTaxReportingFormsContent } from '../../graphql/pimcore/modules/siteContent/types/AboutInvestorRelationsContent';
import LogoLink from '../distributorPortalPage/LogoLink';
import Typography from '@mui/material/Typography';

interface PortalModel {
    mfg: string;
    image: string;
    href: string;
    mfgText: string;
}

interface TaxReportingForms {
    contentTree: AboutInvestorRelationsOverviewTaxReportingFormsContent;
}

const TaxReportingForms: FunctionComponent<TaxReportingForms> = ({ contentTree }) => {
    const { isScreenXs, isScreenSm } = useResponsive();

    const PortalModels: PortalModel[] = [
        {
            mfg: 'form8397(2025)',
            image: contentTree.icon.imageUrl,
            href: contentTree.form2025.linkRoute,
            mfgText: contentTree.form2025.linkText,
        },
        {
            mfg: 'form8397(2022)',
            image: contentTree.icon.imageUrl,
            href: contentTree.form2022.linkRoute,
            mfgText: contentTree.form2022.linkText,
        },
        {
            mfg: 'form8397(2018)',
            image: contentTree.icon.imageUrl,
            href: contentTree.form2018.linkRoute,
            mfgText: contentTree.form2018.linkText,
        },
    ];
    return (
        <Box
            sx={{
                position: 'relative',
                backgroundColor: '#FCE3DA',
                overflow: 'hidden',
                pb: 9,
            }}
        >
            <Box
                sx={{
                    position: 'absolute',
                    bottom: 0,
                    left: 0,
                    right: 0,
                    height: '400px',
                    visibility: 'hidden',
                    zIndex: -1,
                }}
            />

            <Typography
                sx={{
                    fontSize: isScreenSm || isScreenXs ? '16px' : '30px',
                    color: '#B75332',
                    fontWeight: 700,
                    fontFamily: 'Poppins',
                    textAlign: 'center',
                    mt: 8,
                    mb: 3,
                }}
            >
                {contentTree.title.content}
            </Typography>

            <Box
                sx={{
                    margin: '4rem 0',
                    width: '100%',
                    display: 'flex',
                    flexWrap: 'wrap',
                    justifyContent: 'center',
                    alignItems: 'center',
                    gap: '2rem',
                    flexDirection: isScreenSm ? 'column' : 'row',
                    '& [data-testid$="_main_container"]': {
                        backgroundColor: '#F2F2F2',
                        border: '1px solid grey',
                        transition: 'box-shadow .25s ease, transform .25s ease',
                        maxHeight: '220px',
                        maxWidth: '220px',
                    },
                    '& [data-testid$="_main_container"]:hover': {
                        boxShadow: '0 8px 24px rgba(0,0,0,0.12)',
                        transform: 'translateY(-2px)',
                    },
                    '& [data-testid$="_content_container"]': {
                        gap: '2rem',
                    },
                    '& [data-testid$="_image_container"]': {
                        height: '60px',
                    },
                    '& [data-testid$="_image_container"] img': {
                        objectFit: 'contain',
                        maxHeight: '60px',
                        width: 'auto',
                    },
                    '& [data-testid$="_text_container"] .MuiTypography-root': {
                        fontSize: { xs: '18px', md: '24px' },
                        lineHeight: 1.3,
                        fontWeight: 600,
                        color: 'black',
                        fontFamily: 'Poppins',
                    },
                }}
            >
                {PortalModels.map((model) => (
                    <LogoLink
                        key={model.mfg}
                        mfg={model.mfg}
                        image={model.image}
                        href={model.href}
                        mfgText={model.mfgText}
                    />
                ))}
            </Box>
        </Box>
    );
};

export default TaxReportingForms;
